/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import ko from 'knockout';
import axios from 'axios';
import numeral from 'numeral';

class templateWidgetModel {

    constructor(params) {
        // Profile
        //this.log("template-widget");
        //this.log(params);

        numeral.defaultFormat('0,0');

        this.componentName = "jdm-widget";
        this.debug = true;
        this.context = context;
        this.id = params.id;
        this.index = ko.observable(params.index);
        this.visible = ko.observable(true);
        this.editable = ko.observable(params.editable);
        this.editableItems = ko.observable(params.editableItems);

        this.type = ko.observable(params.title);
        this.title = ko.observable(params.title);
        this.occ = params.occ;
        this.apiFunction = params.apiFunction;
        this.expanded = ko.observable(false);
        this.include = ko.observable(true);
        this.css = ko.observable("");

        this.itemCount = ko.observable(5);
        this.subItemCount = ko.observable(5);

        this.fullUrl = "";

        this.content = ko.observable("");

        //console.log("OCC: " + this.occ);
        //console.log("this.editableItems: " + this.editableItems());

        this.getData();
    }

   

    clickExpanded() {
        console.log("clickExpanded");
        this.expanded(!this.expanded());
        console.log(this.expanded());
    }

    getData() {


        let filter = encodeURI(JSON.stringify({ "where" : { "subid" : context.subid()}, "order": "title"}));
        let url = context.generateApiUrl('/Jobs/job/' + this.apiFunction + '?filter=' + filter );
        let callData = JSON.stringify({"occ": this.occ});

        console.log(url);

        if(this.apiFunction != "")
        {
            this.content("");

            axios({
                url: url,
                method: 'post',
                headers: this.context.apiContentType,
                data: callData
            }).then((response) => {
                //this.log(response.data);
                this.handleGetData(response.data.data);
            }).catch((error) =>{
                console.log("Template-widget:getData Error: %s", error);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting for Template Widget:" + this.apiFunction},"messageModel");
            });

        }
    }

    clickMoveUp(item, parents) {
        console.log("clickMoveUp");
        console.log(item);
        console.log(parents);
    }

    clickMoveDown(item, parents) {
        console.log("clickMoveDown");
        console.log(item);
        console.log(parents);
    }


    handleGetData(data)
    {
        //console.log(data);

        let localItemCount = this.getItemCount(data);
        let techData = [];

        switch(this.type())
        {
            case "Title":
                this.content('<h1 class="jdm">' + data[0].title + '</h1>');
                break;
            case "Summary":
                this.content('<p class="jdm">' + data[0].description + '</p>');
                break;
            case "Tasks":
                this.content('<h3 class="jdm">' + this.title() + '</h3> <ul class="jdm ' + this.css() + '" >');
                
                for(var i=0, len=localItemCount; i < len; i++)
                {
                    this.content(this.content() + '<li class="jdm">' + data[i].Task + '</li>');
                }

                this.content(this.content() + ' </ul>');
            break;

            case "Technology":
            case "Tools":
                techData = this.formatMultiItemArray(data);
                localItemCount = this.getItemCount(techData);

                this.content('<h3 class="jdm">' + this.title() + '</h3> <ul class="jdm ' + this.css() + '" >');
                
                for(var i=0, len=localItemCount; i < len; i++)
                {
                    this.content(this.content() + '<li class="jdm"><strong>' + techData[i].title + '</strong>&nbsp;-&nbsp;' + this.formatSubItems(techData[i].items) + '</li>');
                }

                this.content(this.content() + ' </ul>');
            break;

            case "Interests":
            case "Work Values":
            case "Work Activities":
            case "Work Styles":
            case "Knowledge":
            case "Skills":
            case "Abilities":
                this.content('<h3 class="jdm">' + this.title() + '</h3> <ul class="jdm ' + this.css() + '" >');
                
                for(var i=0, len=localItemCount; i < len; i++)
                {
                    //this.log(data[i]);
                    this.content(this.content() + '<li class="jdm"><strong>' + data[i].element_name + '</strong>&nbsp;-&nbsp;' + data[i].Description + '</li>');
                }

                this.content(this.content() + ' </ul>');
            break;

            case "Work Context":
                this.content('<h3 class="jdm">' + this.title() + '</h3> <ul class="jdm ' + this.css() + '" >');
                
                
                for(var i=0, len=localItemCount; i < len; i++)
                {
                    //this.log(data[i]);
                    this.content(this.content() + '<li class="jdm"><strong>' + data[i].element_name + '</strong>&nbsp;-&nbsp;' + this.formatPercent(data[i].data_value) + " responded &#39;" + data[i].category_description + '&#39;</li>');
                }

                this.content(this.content() + ' </ul>');

            break;

            default :
                this.content("");

        }

    }

    formatPercent(numberStr)
    {
        if(!isNaN(numberStr))
        {
            numberStr = numberStr.toString();
        }
        
        let numberStrArray = [];
        numeral.defaultFormat('0,0');
        numberStrArray = numberStr.split('.',numberStr);

        return numeral("." + numberStrArray[0]).format('0%') 
    }

    formatMultiItemArray(data)
    {
        //this.log("formatMultiItemArray");

        let returnArray = []
        let itemArray = []
        let currentTitle = "";

        for(var i=0, len=data.length; i < len; i++)
        {
            console.log("Process Title: " + data[i].commodity_title);

            if((data[i].commodity_title !== currentTitle) && (currentTitle !== ""))
            {
                if(itemArray.length !== 0)
                {
                    console.log("Adding: " + currentTitle);
                    returnArray.push({title: currentTitle, items: itemArray});
                    itemArray = [];
                }
                else
                {
                    console.log("Clean Item Array");
                }
            }

            // Add Item
            currentTitle = data[i].commodity_title;
            itemArray.push(data[i]);
            
        }

        console.log(returnArray);
        return returnArray;

    }

    formatSubItems(items)
    {
        let localItemCount = this.getSubItemCount(items);
        let returnStr = "";

        for(var i=0, len=localItemCount; i < len; i++)
        {
            returnStr = returnStr + items[i].item + "; ";
        }

        return returnStr;

    }

    getItemCount(data)
    {
        if(this.itemCount() == 0)
        {
            return data.length - 1;  
        }
        else if((data.length -1) < this.itemCount())
        {
            return data.length - 1;
        }
        else
        {
            return this.itemCount();
        }
    }

    getSubItemCount(data)
    {
        if(this.subItemCount() == 0)
        {
            return data.length - 1;  
        }
        else if((data.length -1) < this.subItemCount())
        {
            return data.length - 1;
        }
        else
        {
            return this.subItemCount();
        }
    }
    
}

export default { viewModel: templateWidgetModel, template: require('!raw-loader!./jdm-widget.html') };


// WEBPACK FOOTER //
// ./src/components/job-create/sub/jdm-widget.js